import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

import { BuyTicketFormValues } from '@/components/Form/MultiStepForm/BuyTicketForm.type';
import { useMultiStepFormState } from '@/components/Form/MultiStepForm/MultiStepFormContext';
import { EventManagerQuestion } from '@/types/eventManagerQuestion';

interface EventPageAnswerQuestionProps {
  eventManagerQuestions: EventManagerQuestion[];
  onSubmit: () => void;
  onDismiss: () => void;
}

export default function EventPageAnswerQuestion({
  eventManagerQuestions,
  onSubmit,
  onDismiss,
}: EventPageAnswerQuestionProps) {
  // States
  const [answers, setAnswers] = useState<Record<string, string>>({});

  // Hooks
  const { updateFormData } = useMultiStepFormState<BuyTicketFormValues>();
  const t = useTranslations('Pages.Event.EventPageBuyTicketSection');

  // Handlers
  const handleInputChange = (questionId: string, answer: string) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: answer,
    }));
  };

  const handleSubmit = async () => {
    const answersToAdd = Object.entries(answers).map(
      ([questionId, answer]) => ({ eventManagerQuestionId: questionId, answer })
    );

    updateFormData(
      (data) => ({ ...data, answers: answersToAdd }) as BuyTicketFormValues
    );

    if (Object.values(answers).length === eventManagerQuestions.length) {
      onSubmit();
    }
  };

  return (
    <div className='mb-4'>
      <p className='mb-4'>{t('organizerQuestions')}</p>
      {eventManagerQuestions.map((question, index) => (
        <div key={question.id} className='mb-4'>
          <label className='font-bold text-white-filled-default'>
            {index + 1}. {question.question}
          </label>
          <input
            type='text'
            className='mt-2 w-full rounded border border-gray-300 p-2 text-neutral-700'
            onChange={(e) => handleInputChange(question.id, e.target.value)}
          />
        </div>
      ))}
      <div>
        <button
          className='text-white mt-4 w-full rounded bg-primary-filled-default p-1'
          onClick={onDismiss}
        >
          {t('cancel')}
        </button>
        <button
          className='text-white mt-2 w-full rounded border-2 bg-primary-filled-default p-2 font-bold'
          onClick={handleSubmit}
        >
          {t('submitAnswers')}
        </button>
      </div>
    </div>
  );
}
